export const parseQueryParams = (search: string): URLSearchParams => {
  return new URLSearchParams(search);
};
